import React, {useState} from 'react';
import AbstractModalView from 'common/components/AbstractModalView';
import Contact from 'common/components/Contact';
import contactSupportIcon from '../../../common/assets/profile.svg';
import pdfIcon from '../../../common/assets/pdf.svg';
import styles from './styles.module.scss';
import classnames from 'classnames';
import {faqList} from "../../constants/faq";
import QABlock from "../QABlock";

const ModalContactSupportView = ({
                                   showLabelIcon,
                                   handleDownloadPDF,
                                   customLabelStyles
                                 }) => {
  const [modalContactSlide, setModalContactSlide] = useState(false);
  const slideModalContact = () => {
    setModalContactSlide(!modalContactSlide);
  };

  return (
    <AbstractModalView
      subPath={`view-support-popup`}
      modalClassName={styles.modal}
      overlayClassName={styles.overlay}
      triggerContent={({openModal}) => (
        <div
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            openModal();
          }}
          className={classnames(styles.itemContainer, {[styles.customLabelStyles]: customLabelStyles})}
        >
          {showLabelIcon &&
          <img
            src={contactSupportIcon}
            className={styles.icon}
            alt="contact-support-icon"
          />}
          <div className={styles.label}>תמיכה</div>
        </div>
      )}
      modalContent={({closeModal}) => (
        <div className={styles.modalContainer}>
          <h2 className={styles.modalHeader}>מרכז תמיכה</h2>
          <div className={styles.modalContentForm}>
            <h3 className={styles.subHeader}>שאלות נפוצות</h3>
            <div className={styles.modalContentContainer}>
              {faqList.map(item => <QABlock question={item.question} answer={item.answer} />)}
            </div>
            <h3 className={styles.subHeader}>להורדת מדריך שלם לשימוש בפלטפורמה:</h3>
            <div className={styles.downloadPDFContainer}>
              <img
                src={pdfIcon}
                alt="pdf"
                className={styles.downloadPDFIcon}
                onClick={handleDownloadPDF}
              />
              <div className={styles.downloadPDFLabel}>
                מדריך לפלטפורמה
              </div>
            </div>
            <h3 className={styles.subHeader}>עדיין זקוקים לעזרה? לחצו על הלינק הבא כדי ליצור איתנו קשר ישירות:</h3>
            <div
              className={styles.buttonShowModalContact}
              onClick={slideModalContact}
            >
              צור קשר
            </div>
          </div>
          <div className={styles.buttonsContainer}>
            <div
              className={styles.buttonCancel}
              onClick={closeModal}
            >
              <span>סגירה</span>
            </div>
          </div>
          <Contact
            modalContactSlide={modalContactSlide}
            slideModalContact={slideModalContact}
          />
        </div>
      )}
    />
  );
}


export default ModalContactSupportView;
